import moment from "moment-timezone";

class SchedulePdfController {
    constructor($http, $sce) {
        'ngInject';
        this.$http = $http;
        this.$sce = $sce;
    }

    $onChanges(changes) {
        if (changes.scheduleTypes && changes.patient) {
            this.fetchPdf(changes.patient.currentValue, changes.scheduleTypes.currentValue)
        } else if (changes.scheduleTypes) {
            this.fetchPdf(this.patient, changes.scheduleTypes.currentValue)
        } else if (changes.patient) {
            this.fetchPdf(changes.patient.currentValue, this.scheduleTypes)
        }
    }

    fetchPdf(patient, scheduleTypes) {
        if (this.fetchCancellation) {
            this.fetchCancellation.requestCancel = true
        }

        // must generate a NEW object and have it captured by the promise chain
        const fetchCancellation = {requestCancel: false}
        this.fetchCancellation = fetchCancellation

        this.updateIsLoading(true)
        this.$http.post('/mobile/webClient/downloadMedSchedules', {
            patientUuid: patient.patient.uuid,
            medScheduleIds: scheduleTypes,
            timezone: moment.tz.guess(),
        }, {
            responseType: 'blob'
        }).then(response => {
            if (!fetchCancellation.requestCancel) {
                if (this.pdfBlobUrl) {
                    URL.revokeObjectURL(this.pdfBlobUrl)
                }
                this.pdfBlobUrl = this.$sce.trustAsResourceUrl(URL.createObjectURL(response.data))
                this.updateIsLoading(false)
            }
        })
    }

    updateIsLoading(value) {
        this.isLoading = value;
        this.onFileReadyChanged({isFileReady: !value})
    }

    formatName(patient) {
        return `${patient.patient.firstName}${patient.patient.middleInitial ? " ": ""}${patient.patient.middleInitial} ${patient.patient.lastName}`
    }
}

export const SchedulePdfComponent = {
    name: 'schedulePdf',
    component: {
        template: `
        <div class="schedule-pdf-header border-box">
            <div class="pdf-header-left">
                <profile-icon patient="$ctrl.patient"></profile-icon>                
                <span>{{$ctrl.formatName($ctrl.patient)}}</span>
            </div>
            <div class="pdf-header-right">
                <div><span class="label">Last updated: </span><span class="value">{{$ctrl.patient.schedule.lastUpdatedAt | dateTimeStr}}</span></div>                
                <div><span class="label">By: </span><span class="value">{{$ctrl.patient.schedule.lastUpdatedBy}}</span></div>                
            </div>
        </div>
        <div class="pdf-iframe border-box">
            <loading-animation ng-if="$ctrl.isLoading"></loading-animation>
            <iframe id="pdfViewer" ng-if="!$ctrl.isLoading" ng-src="{{$ctrl.pdfBlobUrl}}"></iframe>        
        </div>        
        `,
        controller: SchedulePdfController,
        bindings: {
            patient: '<',
            scheduleTypes: '<',
            onFileReadyChanged: '&'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/schedulePdf.component.js